@if (isHeader || !notification) {
  <th class="icon-cell hidden-on-mobile"></th>
  <th class="hidden-on-mobile">
    {{ "notification.list.message" | translate }}
  </th>
  <th class="hidden-on-mobile">
    {{ "notification.list.level" | translate }}
  </th>
  <th class="hidden-on-mobile">
    {{ "notification.list.trigger" | translate }}
  </th>
  <th class="hidden-on-mobile">
    {{ "notification.list.date" | translate }}
  </th>
  <th class="icon-cell hidden-on-mobile"></th>
  <th class="icon-cell hidden-on-mobile"></th>
} @else {
  <td class="icon-cell border" [class.unread]="!notification.readAt">
    @if (notificationContent.icon) {
      <app-icon [name]="notificationContent.icon | icons" />
    }
  </td>
  <td
    class="message-cell border"
    [class.unread]="!notification.readAt"
    [attr.data-label]="'notification.list.message' | translate"
  >
    <h4>{{ notificationContent.headline }}</h4>
    <p>{{ notificationContent.text }}</p>
  </td>
  <td [attr.data-label]="'notification.list.level' | translate">
    <app-tag size="small" [level]="notification.level">
      {{
        LabelConverter.getNotificationLevelLabel(notification.level) | translate
      }}
    </app-tag>
  </td>
  <td>
    {{
      notification.userEmail || notification.client
        ? (notification.userEmail || "") +
          (notification.userEmail && notification.client ? " | " : "") +
          (notification.client || "")
        : "-"
    }}
  </td>
  <td [attr.data-label]="'notification.list.date' | translate">
    {{ notification.eventDate | localizedDate }},
    {{ notification.eventDate | time }}
  </td>
  <td class="icon-cell action-cell">
    @if (!notification.readAt) {
      <button
        class="button icon-button"
        type="button"
        [title]="'notification.markAsRead' | translate"
        (click)="onMarkAsRead()"
      >
        <app-icon name="ic_eye_open" />
      </button>
    }
  </td>
  <td class="icon-cell action-cell">
    @if (hasLink) {
      <button
        type="button"
        class="button icon-button"
        (click)="markAsReadAndNavigateToRouterLink()"
      >
        <app-icon name="ic_chevron_right" />
      </button>
    }
  </td>
}
